export const REP_CLICK_URL = "https://reps.solarlab.global/api.php?a=rf_click"

/**
 * One beacon per Call or Send an email click.
 * `rep` is the address from the CRM list. Body is JSON as text/plain so the browser does not preflight.
 */
export function repClickBody({ action, rep, code } = {}) {
  return {
    action: action === "call" ? "call" : "email",
    rep: String(rep?.email || "")
      .trim()
      .replace(/[\r\n]/g, ""),
    code: String(code || "").trim().toUpperCase(),
  }
}

export function repClickRequest(payload) {
  return {
    url: REP_CLICK_URL,
    body: new Blob([JSON.stringify(payload)], { type: "text/plain" }),
  }
}

export function recordRepContactClick(details, sendBeacon = sendRepClick) {
  const payload = repClickBody(details)
  try {
    sendBeacon(payload)
  } catch {
    // The tel: or mailto: navigation still proceeds.
  }
  return payload
}

function sendRepClick(payload) {
  const send = globalThis.navigator?.sendBeacon?.bind(globalThis.navigator)
  if (!send) return false
  const { url, body } = repClickRequest(payload)
  return send(url, body)
}
